import { ExternalLink } from "lucide-react";
import { storefrontUrl } from "../lib/storefront";
import { cx } from "../lib/cx";

export function StorefrontPreviewLink({
  path,
  label = "پیش‌نمایش در سایت",
  disabled = false,
  className,
}: {
  path?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
}) {
  if (!path || disabled) {
    return (
      <span className={cx("button button--ghost is-disabled", className)} aria-disabled="true" title="ابتدا این مورد را ذخیره و در صورت نیاز منتشر کنید.">
        <ExternalLink size={16} /> {label}
      </span>
    );
  }

  return (
    <a className={cx("button button--ghost", className)} href={storefrontUrl(path)} target="_blank" rel="noreferrer">
      <ExternalLink size={16} /> {label}
    </a>
  );
}
